export class InstancesContext {
    name: string;
    instanceContextId: string;
}
